import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined'
import { Trans } from 'react-i18next'

export const SCHEDULED_MAINTENANCE_BANNER_HEIGHT = 40
export const SCHEDULED_MAINTENANCE_MOBILE_BANNER_HEIGHT = 62

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    zIndex: theme.zIndex.appBar + 1,
    top: 0,
    right: 0,
    left: 0,
    height: SCHEDULED_MAINTENANCE_BANNER_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    backgroundColor: '#FFFDF5',
    borderTop: '1px solid rgba(136, 112, 78, 0.12)',
    borderBottom: '1px solid rgba(136, 112, 78, 0.12)',
    color: '#403A33',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      height: SCHEDULED_MAINTENANCE_MOBILE_BANNER_HEIGHT,
      alignItems: 'flex-start',
      paddingTop: theme.spacing(0.75)
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    color: '#9A8570',
    fontSize: 18,
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 1
    }
  },
  text: {
    fontSize: 13,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
      whiteSpace: 'normal'
    }
  },
  window: {
    color: '#403A33',
    fontWeight: 700
  }
}))

function ScheduledMaintenanceBanner () {
  const classes = useStyles()

  return (
    <div className={classes.root} role='status'>
      <BuildOutlinedIcon aria-hidden='true' className={classes.icon} />
      <Typography className={classes.text} variant='body2'>
        <Trans
          components={{ maintenanceWindow: <strong className={classes.window} /> }}
          i18nKey='scheduledMaintenanceBanner'
          ns='topBar'
        />
      </Typography>
    </div>
  )
}

export default ScheduledMaintenanceBanner
